document.addEventListener('DOMContentLoaded', function() {
  // Function to handle the click event on the Profile tab
  function handleProfileTabClick() {
    // Remove the active class from all tabs
    $('.box-wrapper').removeClass('active');
    
    // Add the active class to the Profile tab
    $(this).closest('.box-wrapper').addClass('active');

    // Show the Profile section and hide the Order section
    $('.profile_sec').addClass('active');
    $('.order_sec').removeClass('active');

    // Store the state of the active tab in localStorage
    localStorage.setItem('activeTab', 'profile');
  }

  // Function to handle the click event on the Order tab
  function handleOrderTabClick() {
    // Remove the active class from all tabs
    $('.box-wrapper').removeClass('active');
    
    // Add the active class to the Order tab
    $(this).closest('.box-wrapper').addClass('active');

    // Show the Order section and hide the Profile section
    $('.order_sec').addClass('active');
    $('.profile_sec').removeClass('active');

    // Store the state of the active tab in localStorage
    localStorage.setItem('activeTab', 'order');
  }

  // Event listener for clicking on the Profile tab
  $(".profile_sec .account_address_icon").click(handleProfileTabClick);

  // Event listener for clicking on the Order tab
  $(".order_sec .account_address_icon").click(handleOrderTabClick);

  // Check if there's a stored state for the active tab
  const activeTab = localStorage.getItem('activeTab');
  if (activeTab === 'order') {
    // If the Order tab was active, trigger a click event on it
    $(".order_sec .account_address_icon").click();
  } else {
    // Otherwise, trigger a click event on the Profile tab (default)
    $(".profile_sec .account_address_icon").click();
  }
});


$(document).ready(function(){
    $('.logo_text_multicolumn').slick(
    {
      infinite: false,
      speed: 300,
      centerMode: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      prevArrow:"<button type='button' class='slick-prev pull-left'><img src='https://cdn.shopify.com/s/files/1/0650/3769/7263/files/subs-arrow-icon2.svg?v=1722491372'></button>",
      nextArrow:"<button type='button' class='slick-next pull-right'><img src='https://cdn.shopify.com/s/files/1/0650/3769/7263/files/subs-arrow-icon1.svg?v=1722491334'></button>",
      responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
{
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        
      }
    }
  ]
    }
);
});



